import React from 'react';
import Dialog, { type DialogProps } from '@mui/material/Dialog';
import { type TransitionProps } from '@mui/material/transitions';

export type LazyDialogProps = DialogProps & {
  TransitionProps?: TransitionProps;
  children?: React.ReactNode;
  classes?: DialogProps['classes'];
  'data-testid'?: string;
  isRendered?: boolean;
  onClose?(e: React.SyntheticEvent): void;
};

/**
 * This is a thin wrapper around <Dialog> with the main intent of ensuring the
 * necessary props are included when lazy loading a dialog from
 * <DialogManagerProvider>
 */
export default function LazyDialog({
  TransitionProps = {},
  children,
  classes = {},
  isRendered,
  onClose = () => {},
  'data-testid': dataTestid,
  ...props
}: LazyDialogProps) {
  // isRendered is used to remove the component altogether when it has finished
  // transitioning out of the render tree.
  if (!isRendered) {
    return null;
  }

  return (
    <Dialog
      TransitionProps={TransitionProps}
      classes={classes}
      onClose={onClose}
      data-testid={dataTestid}
      {...props}
    >
      {children}
    </Dialog>
  );
}
